import { Loader2 } from 'component/Loader2/Loader2'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useEffect, useMemo, useState } from 'react'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'
import { notEmptyString } from 'util/string'
import css from './ProcessingBottom.module.scss'

type Props = {
  inference: InferenceStore
}

export const ProcessingBottom = observer(({ inference }: Props) => {
  const size = opt.stand ? 20 : 14
  const start = useMemo(() => Date.now(), [])
  const [indexes, setIndexes] = useState<[number, number]>([-1, 0])
  const [prev, next] = indexes

  const mocks = [
    i18n('CreatingOutfitMock0') || i18n('CreatingOutfitShort'),
    i18n('CreatingOutfitMock1'),
    i18n('CreatingOutfitMock2'),
    i18n('CreatingOutfitMock3'),
    i18n('CreatingOutfitMock4'),
    i18n('CreatingOutfitMock5'),
    i18n('CreatingOutfitMock6'),
    i18n('CreatingOutfitMock7'),
    i18n('CreatingOutfitMock8'),
    i18n('CreatingOutfitMock9'),
  ].filter(notEmptyString)

  const update = useLatestCallback(() => {
    const single = 5000
    const passed = Date.now() - start
    if (passed < single) return

    // showing first mock only once, at start
    const update = Math.trunc(Math.trunc(passed / single) % (mocks.length - 1)) + 1
    if (update !== next) setIndexes([next, update])
  })

  useEffect(() => {
    const id = setInterval(update, 10)
    return () => clearInterval(id)
  }, [])

  const hint = i18n('CreatingOutfitHint')

  return (
    <Vertical gap={16} wide tall center>
      <Loader2 size={24} />
      <Vertical gap={8} wide center>
        <Space wide center>
          {prev >= 0 && <Typo key={prev} className={css.prev} size={size} medium upper center>
            {mocks[prev]}
          </Typo>}
          <Typo key={next} className={css.next} size={size} medium upper center>
            {mocks[next]}
          </Typo>
        </Space>
        <Typo size={size} pre center>
          {hint}
        </Typo>
      </Vertical>
    </Vertical>
  )
})
